import { useEffect, useState } from "react";

const navItems = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={[
        "sticky top-0 z-50 border-b transition-all",
        scrolled
          ? "bg-white/90 backdrop-blur border-black/10"
          : "bg-white border-black/10",
      ].join(" ")}
    >
      <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-xl bg-white grid place-items-center">
            <img
              src="/jwclogo_no_text.png"
              alt="JW Cyclone Security Logo"
              className="h-6 w-6 object-contain"
            />
          </div>

          <div className="leading-tight">
            <div className="font-semibold tracking-tight">
              JW Cyclone Security
            </div>
            <div className="text-xs text-black/60">Security & Protection</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-7 text-sm">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-black/70 hover:text-black transition"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            className="inline-flex items-center rounded-xl bg-ink text-white px-4 py-2 text-sm hover:opacity-90 transition"
          >
            Get a Quote
            <span className="ml-2 text-redAccent">●</span>
          </a>
        </nav>

        <a
          href="#contact"
          className="md:hidden inline-flex items-center rounded-xl bg-ink text-white px-3 py-2 text-sm"
        >
          Contact
        </a>
      </div>
    </header>
  );
}
